export module DTO {
  export const toObject = <T>(dto: T): Record<string, unknown> => {
    return JSON.parse(JSON.stringify(dto))
  }

  export const toArray = <T>(dtoArray: T[]): Record<string, unknown>[] => {
    return dtoArray.map(dto => toObject(dto))
  }
}
